import { useState, useEffect, useMemo } from 'react';
import { toast } from 'react-toastify';

import { Collapsible, CollapsibleContent } from "@shadcn/components/ui/collapsible";

import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@shadcn/components/ui/select';

import {
  Card,
  CardContent as CardBody,
  CardHeader,
} from '@shadcn/components/ui/card';

import { Row } from '@shadcn/components/ui/row';
import { Col } from '@shadcn/components/ui/col';
// Editable
import { useHistory } from 'react-router-dom';
import superagent from 'superagent';
import moment from 'moment';

//Import Breadcrumb
import useQuery from '../../../helpers/JIFI/useQuery';
import { backendUrl } from '../../../helpers/consts.js';

import { CSVReader } from 'react-papaparse';
import { CSVLink } from 'react-csv';

import SupplyChainNav from '../../../components/supply-chain/nav.js';
import CommentHostory from '../../Skote/Dashboard/CommentHistory.js';
import { Badge } from '@shadcn/components/ui/badge';
import { Button } from '@shadcn/components/ui/button';
import { Input as InputShadcn } from '@shadcn/components/ui/input';
import {
  Dialog,
  DialogContent,
  DialogFooter,
  DialogHeader,
} from '@shadcn/components/ui/dialog';

const statusToBadge = (status) => {
  const conversion = {
    approved: 'badge-soft-success',
    disapproved: 'badge-soft-danger',
    pending: 'badge-soft-warning',
  };
  return conversion[status];
};

export const CustomInput = ({ value, onChange, isPrefix = false, preSufix = "$", ...props }) => {
  return (
    <div

      className={`flex items-center border border-black  rounded-md ${!isPrefix ? 'border-r-1' : "border-l-0"}`}

    >
      {isPrefix && <div className="flex items-center px-3 bg-gray-100 border-r border-l rounded-l-md border-black  h-9">
        <span className="text-gray-500">{preSufix}</span>
      </div>}
      <InputShadcn
        type="number"
        value={value}
        onChange={onChange}

        className={`border-none font-normal text-base focus:ring-0 focus:outline-none rounded-none ${!isPrefix ? 'rounded-l-md' : "rounded-r-md"} h-9`}
        {...props}
      />
      {!isPrefix &&
        <div className="flex items-center px-3 bg-gray-100 border-l border-black rounded-r-md h-9">
          <span className="text-gray-500">{preSufix}</span>
        </div>
      }
    </div>
  );
};

const Accordian = ({ children, title, close }) => {
  const [open, setOpen] = useState(false);
  useEffect(() => {
    if (close === true) {
      setOpen(false);
    }
  }, [close]);
  return (
    <>
      <div id="accordion">
        <Card className="mb-1 bg-[#f6f6f6] border-b-0 border-b-[#f6f6f6] font-medium">
          <CardHeader
            onClick={() => setOpen((prev) => !prev)}
            className="p-3"
            id="headingOne"
          >
            <h6 className="m-0 font-14">
              <span style={{ cursor: 'pointer' }} className={''}>
                {title}
              </span>
            </h6>
          </CardHeader>
          <Collapsible open={open} onOpenChange={() => setOpen((prev) => !prev)}>
            <CollapsibleContent>
              <Card>
                <CardBody>{children}</CardBody>
              </Card>
            </CollapsibleContent>
          </Collapsible>
        </Card>
      </div>
      <br />
      <br />
    </>
  );
};
const getVariantId = (variant) => {
  if (!variant) return null;
  if (typeof variant === 'string') return variant;
  if (typeof variant === 'object') return variant._id ?? variant.id ?? null;
  return null;
};

const getFactoryFobValue = (variant, fobMap) => {
  const variantId = getVariantId(variant);
  if (!variantId) return 0;

  const value = fobMap.get(String(variantId));
  const numericValue = Number(value);

  return Number.isFinite(numericValue) && numericValue >= 0 ? numericValue : 0;
};

const normalizeLine = (line) => {
  if (!line) {
    return null;
  }

  const variantId = getVariantId(line.variant);
  if (!variantId) {
    return null;
  }

  const quantityValue = Number.parseInt(line.quantity ?? 0, 10);
  const costValue = Number.parseFloat(line.cost ?? 0);

  return {
    variant: String(variantId),
    sku: line.sku ?? line.variant?.sku ?? '',
    quantity: Number.isFinite(quantityValue) && quantityValue >= 0 ? quantityValue : 0,
    cost: Number.isFinite(costValue) && costValue >= 0 ? costValue : 0,
  };
};

const normalizeLines = (lines) => {
  if (!Array.isArray(lines)) {
    return [];
  }

  return lines.map(normalizeLine).filter(Boolean);
};

const reconcileLinesWithFactory = (lines, allowedIdsSet, lookup, fobMap) => {
  if (!Array.isArray(lines) || !(allowedIdsSet instanceof Set)) {
    return { changed: false, lines: lines ?? [] };
  }

  const remaining = new Set(allowedIdsSet);
  const nextLines = [];
  let changed = false;

  for (const line of lines) {
    const normalized = normalizeLine(line);
    if (!normalized) {
      changed = true;
      continue;
    }

    const currentId = normalized.variant;
    if (remaining.has(currentId)) {
      remaining.delete(currentId);
      const variant = lookup.get(currentId);
      nextLines.push({
        ...normalized,
        sku: normalized.sku || variant?.sku || '',
      });
      continue;
    }

    const fallbackId = Array.from(remaining)[0];
    if (!fallbackId) {
      changed = true;
      continue;
    }

    remaining.delete(fallbackId);
    const variant = lookup.get(fallbackId);
    nextLines.push({
      variant: fallbackId,
      sku: variant?.sku || '',
      quantity: 0,
      cost: getFactoryFobValue(variant, fobMap),
    });
    changed = true;
  }

  return { changed, lines: nextLines };
};

const parseCsvData = (data, filteredVariants, factoryFobMap) => {
  const parsedItems = [];
  const invalidSkus = [];

  data.forEach((line, index) => {
    if (index === 0) return;

    const [sku, cost, quantity] = line.data;
    const variant = filteredVariants.find((v) => v.sku === sku);

    if (!variant) {
      if (sku) invalidSkus.push(sku);
      return;
    }

    const parsedCost = Number.parseFloat(cost);
    const hasValidCost = Number.isFinite(parsedCost) && parsedCost >= 0;
    const resolvedCost = hasValidCost ? parsedCost : getFactoryFobValue(variant, factoryFobMap);

    parsedItems.push({
      variant: String(variant._id),
      quantity: Number.parseInt(quantity, 10) || 0,
      cost: resolvedCost,
      sku,
    });
  });

  return { parsedItems, invalidSkus };
};

const StockInput = ({ stock, setStock, productData, noCost, factoryFobMap }) => {
  const getFactoryFob = (variant) => {
    if (noCost) return 0;
    return getFactoryFobValue(variant, factoryFobMap);
  };

  const handleAddRow = () => {
    if (!Array.isArray(productData) || productData.length === 0) {
      toast.warn('No variants available for this factory');
      return;
    }

    const usedVariantIds = new Set(
      stock.map((item) => String(getVariantId(item.variant))).filter(Boolean)
    );

    const nextVariant = productData.find(
      (variant) => !usedVariantIds.has(String(variant._id))
    );

    if (!nextVariant) {
      toast.warn('No more variants available for this factory');
      return;
    }

    setStock((prev) => [...prev, {
      variant: String(nextVariant._id),
      sku: nextVariant.sku ?? '',
      quantity: 0,
      cost: getFactoryFob(nextVariant),
    }]);
  };

  const editVariantRow = (id, val) => {
    const variant = productData.find((p) => String(p._id) === String(val));
    if (!variant) return;

    setStock((prev) => {
      const newList = [...prev];
      newList[id] = {
        ...newList[id],
        variant: String(val),
        sku: variant.sku ?? '',
        quantity: 0,
        cost: getFactoryFob(variant),
      };
      return newList;
    });
  };

  const editQuantityRow = (id, val) => {
    const parsedValue = Number.parseInt(val, 10);
    const quantity = Number.isFinite(parsedValue) && parsedValue >= 0 ? parsedValue : 0;

    setStock((prev) => {
      const newList = [...prev];
      newList[id].quantity = quantity;
      return newList;
    });
  };

  const editcostRow = (id, val) => {
    const parsedValue = Number.parseFloat(val);
    const cost = Number.isFinite(parsedValue) && parsedValue >= 0 ? parsedValue : 0;

    setStock((prev) => {
      const newList = [...prev];
      newList[id].cost = cost;
      return newList;
    });
  };

  const removeRow = (id) => {
    setStock((prev) => prev.filter((_, index) => index !== id));
  };

  const getAvailableVariants = (lineIndex) => {
    if (!Array.isArray(productData)) return [];

    const taken = new Set(
      stock
        .map((item, index) => index === lineIndex ? null : String(getVariantId(item.variant)))
        .filter(Boolean)
    );

    const options = productData.filter((variant) => !taken.has(String(variant._id)));

    const currentId = getVariantId(stock[lineIndex]?.variant);
    if (currentId && !options.some((opt) => String(opt._id) === String(currentId))) {
      options.unshift({
        _id: currentId,
        name: stock[lineIndex]?.sku || currentId,
        sku: stock[lineIndex]?.sku || '',
      });
    }

    return options;
  };

  return (
    <>
      <Row>
        <Col className="sm:w-4/12">Variant</Col>
        {noCost !== true && <Col className="sm:w-4/12">Cost</Col>}
        <Col className="sm:w-3/12">Quantity</Col>
      </Row>
      {stock.map((line, lineKey) => {
        const availableVariants = getAvailableVariants(lineKey);
        const selectedVariantId = String(getVariantId(line.variant) ?? '');

        return (
          <Row key={`line-${lineKey}`} style={{ padding: '12px 0', gap: '12px' }}>
            <Col className="sm:w-4/12">
              <Select
                value={selectedVariantId || undefined}
                onValueChange={(value) => editVariantRow(lineKey, value)}
              >
                <SelectTrigger>
                  <SelectValue placeholder="Please select variant" />
                </SelectTrigger>
                <SelectContent className="z-[1600]">
                  {availableVariants.map((variant) => (
                    <SelectItem key={variant._id} value={String(variant._id)}>
                      {variant.name || variant.sku || variant._id}
                    </SelectItem>
                  ))}
                </SelectContent>
              </Select>
            </Col>
            {noCost !== true && (
              <Col className="sm:w-4/12">
                <CustomInput
                  value={line.cost}
                  onChange={(event) => editcostRow(lineKey, event.target.value)}
                />
              </Col>
            )}
            <Col className="sm:w-3/12">
              <InputShadcn
                type="number"
                value={line.quantity}
                onChange={(event) => editQuantityRow(lineKey, event.target.value)}
              />
            </Col>
            <Col className="sm:w-1/12">
              <Button onClick={() => removeRow(lineKey)} variant="destructive">
                X
              </Button>
            </Col>
          </Row>
        );
      })}
      {Array.isArray(productData) && productData.length > 0 && (
        <div
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            width: '100%',
            marginTop: 12,
          }}
        >
          <Button
            disabled={!Array.isArray(productData) || stock.length >= productData.length}
            onClick={handleAddRow}

          >
            Add{' '}
          </Button>{' '}
          <span />
        </div>
      )}
    </>
  );
};

const PurchaseOrderPage = ({ match: { params } }) => {
  const { purchaseOrderID } = params;

  const [reference, setReference] = useState('');
  const [currency, setCurrency] = useState('USD');
  const [factory, setFactory] = useState('');
  const [accountCode, setAccountCode] = useState('');
  const [lines, setLines] = useState([]);

  const [requestedDate, setRequestedDate] = useState('');
  const [expectedReleaseDate, setExpectedReleaseDate] = useState('');
  const [originalReleaseDate, setOriginalReleaseDate] = useState('');

  const history = useHistory();
  const [loadingSave, setLoadingSave] = useState(false);
  const [refresh, setRefresh] = useState(false);
  const refreshData = () => setRefresh((prev) => !prev);

  const [releaseModalOpen, setReleaseModalOpen] = useState(false);

  const [purchaseOrder, purchaseOrderState] = useQuery({
    url: `/purchase-order/${purchaseOrderID}`,
    refresh,
  });
  const [productData, productState] = useQuery({
    url: `/product`,
    refresh,
  });
  const [factories, factoriesState] = useQuery({
    url: `/factory/all`,
    refresh,
  });
  const [xeroAccounts, xeroAccountsState] = useQuery({
    url: `/xero/account-dropdown`,
    refresh,
  });

  console.log('xeroAccounts', xeroAccounts);
  const factoryData = factories?.data;
  const variants = productData
    ? productData.data.map((product) => product.variants).flat()
    : [];
  const selectedFactory = factoryData?.find((val) => val._id === factory);

  const variantMap = useMemo(() => {
    return new Map(
      variants.map((variant) => [String(variant._id), variant])
    );
  }, [variants]);

  const factoryFobMap = useMemo(() => {
    if (!selectedFactory?.variantLines) {
      return new Map();
    }

    const entries = selectedFactory.variantLines.map((line) => {
      const rawVariantId = getVariantId(line.variant);
      if (!rawVariantId) return null;
      const variantId = String(rawVariantId);
      const numericValue = Number.parseFloat(line.currentFOB);
      if (!Number.isFinite(numericValue) || numericValue < 0) {
        return [variantId, 0];
      }
      return [variantId, numericValue];
    }).filter(Boolean);

    return new Map(entries);
  }, [selectedFactory]);

  const factoryVariantIdsSet = useMemo(() => {
    if (!selectedFactory?.variantLines) {
      return null;
    }

    const ids = selectedFactory.variantLines
      .map((line) => getVariantId(line.variant))
      .filter(Boolean)
      .map((id) => String(id));

    return new Set(ids);
  }, [selectedFactory]);

  const filteredVariants = variants.filter((val) => {
    if (!factoryVariantIdsSet) return true;
    const variantId = val?._id;
    if (!variantId) return false;
    return factoryVariantIdsSet.has(String(variantId));
  });

  useEffect(() => {
    if (!purchaseOrder) {
      return;
    }

    setReference(purchaseOrder.reference);
    setLines(normalizeLines(purchaseOrder.lines));
    setFactory(purchaseOrder.factory);
    setAccountCode(purchaseOrder.accountCode || '');
    setCurrency(purchaseOrder.currency || 'USD');

    setRequestedDate(
      moment(purchaseOrder.requestedDate).format('YYYY-MM-DD')
    );
    setExpectedReleaseDate(
      moment(purchaseOrder.expectedReleaseDate).format('YYYY-MM-DD')
    );
    setOriginalReleaseDate(
      moment(purchaseOrder.originalReleaseDate).format('YYYY-MM-DD')
    );
  }, [purchaseOrder]);

  useEffect(() => {
    if (purchaseOrderID !== 'create' || !factoryFobMap?.size) return;

    setLines((prev) => {
      if (!prev?.length) return prev;

      let changed = false;
      const nextLines = prev.map((line) => {
        const variantId = getVariantId(line?.variant);
        if (!variantId) return line;

        const hasValidCost = line.cost !== undefined &&
          line.cost !== null &&
          !(typeof line.cost === 'string' && line.cost.trim() === '');

        if (hasValidCost) return line;

        const fobValue = getFactoryFobValue(line.variant, factoryFobMap);
        if (fobValue === 0) return line;

        changed = true;
        return { ...line, cost: fobValue };
      });

      return changed ? nextLines : prev;
    });
  }, [factoryFobMap, purchaseOrderID]);

  const variantLookup = useMemo(() => {
    return new Map(
      filteredVariants.map((variant) => [String(variant._id), variant])
    );
  }, [filteredVariants]);

  useEffect(() => {
    if (!factoryVariantIdsSet?.size) return;

    setLines((prev) => {
      const { changed, lines: nextLines } = reconcileLinesWithFactory(
        prev,
        factoryVariantIdsSet,
        variantLookup,
        factoryFobMap
      );

      return changed ? nextLines : prev;
    });
  }, [factoryVariantIdsSet, variantLookup, factoryFobMap]);

  const validateDateFormat = (dateString) => {
    if (!dateString) return true;
    const date = moment(dateString, 'YYYY-MM-DD', true);
    return date.isValid();
  };

  const validateFactoryExists = (factoryId) => {
    if (!factoryId) return false;
    return factoryData?.some(factory => factory._id === factoryId);
  };

  const handleSave = (e) => {
    e.preventDefault();
    if (loadingSave) return;


    if (!reference?.trim()) {
      toast.error('Reference is required');
      return;
    }

    if (!factory?.trim()) {
      toast.error('Factory is required');
      return;
    }


    if (!validateDateFormat(requestedDate)) {
      toast.error('Requested Date must be in YYYY-MM-DD format');
      return;
    }

    if (!validateDateFormat(expectedReleaseDate)) {
      toast.error('Expected Release Date must be in YYYY-MM-DD format');
      return;
    }

    if (!validateDateFormat(originalReleaseDate)) {
      toast.error('Original Release Date must be in YYYY-MM-DD format');
      return;
    }


    if (!validateFactoryExists(factory)) {
      toast.error('Selected factory does not exist');
      return;
    }

    setLoadingSave(true);

    const payload = {
      reference,
      lines: normalizeLines(lines),
      factory,
      accountCode,
      currency,
      requestedDate,
      expectedReleaseDate,
      originalReleaseDate,
    };

    const endpoint = purchaseOrderID === 'create'
      ? `${backendUrl}/purchase-order/create`
      : `${backendUrl}/purchase-order/update/${purchaseOrderID}`;

    const method = purchaseOrderID === 'create' ? 'post' : 'put';

    superagent[method](endpoint)
      .send(payload)
      .set('Authorization', `Bearer ${localStorage.getItem('authJWT')}`)
      .set('accept', 'json')
      .then((response) => {
        setLoadingSave(false);
        if (response.status > 400) {

          const errorMessage = response.body?.message || response.body?.response?.message || 'An error occurred';
          toast.error(errorMessage);
        } else {

          if (purchaseOrderID === 'create') {
            history.push(`/purchase-order/${response.body._id}`);
          } else {
            refreshData();
          }
        }
      })
      .catch((err) => {
        setLoadingSave(false);
        console.log(err);


        const statusCode = err?.status || err?.response?.status;
        const errorMessage = err?.response?.body?.message || err?.response?.body?.response?.message || err?.message || 'An error occurred';


        toast.error(errorMessage);
      });
  };

  const handleOnDrop = (data) => {
    const { parsedItems, invalidSkus } = parseCsvData(data, filteredVariants, factoryFobMap);

    if (invalidSkus.length > 0) {
      toast.warn(`Skipped SKU(s) not available for this factory: ${invalidSkus.join(', ')}`);
    }

    if (parsedItems.length === 0) return;

    setLines((prev) => {
      const next = Array.isArray(prev) ? [...prev] : [];

      parsedItems.forEach((line) => {
        const existingIndex = next.findIndex((item) => String(item.variant) === String(line.variant));
        if (existingIndex === -1) {
          next.push(line);
        } else {
          next[existingIndex] = {
            ...next[existingIndex],
            quantity: line.quantity,
            cost: line.cost,
            sku: line.sku,
          };
        }
      });

      return next;
    });
  };

  const handleOnError = (err) => console.log(err);
  const handleOnRemoveFile = (file) => console.log(file);

  const csvData = [
    ['SKU', 'Cost', 'Quantity'],
    ...(lines?.map((line) => [
      variantMap.get(String(line.variant))?.sku ?? line.sku,
      line.cost,
      line.quantity,
    ]) || []),
  ];

  const poData = {};

  if (purchaseOrder) {
    purchaseOrder.lines.map((line) => {
      poData[line.sku] = {
        ordered: line.quantity,
        released: 0,
      };
    });

    if (purchaseOrder && purchaseOrder.releases) {
      purchaseOrder.releases.map((release) => {
        if (release.releaseLines) {
          release.releaseLines.map((releaseLine) => {
            const quantity =
              release.status === 'approved' ? releaseLine.quantity : 0;
            poData[releaseLine.variant.sku] =
              poData[releaseLine.variant.sku] || {};
            poData[releaseLine.variant.sku]['released'] =
              (poData[releaseLine.variant.sku]['released'] || 0) + quantity;
          });
        }
      });
    }
  }

  return (
    <>
      <SupplyChainNav
        commentComponent={
          <CommentHostory
            maxHeight="200px"
            title="Comments"
            initCommentType={'PurchaseOrder'}
            initOrderName={purchaseOrder?.reference ?? ""}
          />
        }
      >
        <div>
          <Row>
            <Col className="w-full">
              <Card className="p-4">
                <CardBody>
                  {purchaseOrderState !== 'loading' ? (
                    <div className="mt-4">
                      <Row className="flex-wrap">
                        <Col className="sm:w-6/12">
                          <div className="mb-4 mr-4">
                            <label htmlFor="locationname">Reference</label>
                            <InputShadcn
                              id="locationname"
                              name="locationname"
                              type="text"
                              className="form-control h-9"
                              value={reference}
                              onChange={(e) => setReference(e.target.value)}
                            />
                          </div>
                          {purchaseOrder ? (
                            <div className="mb-4 mr-4 text-sm" style={{ background: '#f6f6f6', borderRadius: 8, padding: 12 }}>
                              <div><strong>Status:</strong> {purchaseOrder.status || 'pending'}</div>
                              <div><strong>Xero PO:</strong> {purchaseOrder.xeroPOID || '—'}</div>
                              <div><strong>Xero Bill:</strong> {purchaseOrder.xeroBillID || '—'}</div>
                              <div>
                                <strong>Sent to supplier:</strong>{' '}
                                {purchaseOrder.sentToSupplierAt
                                  ? new Date(purchaseOrder.sentToSupplierAt).toLocaleString()
                                  : 'not sent'}
                              </div>
                              {purchaseOrder.approvedBy ? (
                                <div><strong>Approved by:</strong> {purchaseOrder.approvedBy}</div>
                              ) : null}
                            </div>
                          ) : null}
                          <div className="mb-4 mr-4">
                            <label htmlFor="locationname">Factory</label>
                            <Select
                              value={factory}
                              onValueChange={(value) => setFactory(value)}
                            >
                              <SelectTrigger className="h-9">
                                <SelectValue placeholder="Select Factory" />
                              </SelectTrigger>
                              <SelectContent>
                                {factoryData?.map((val) => (
                                  <SelectItem key={val._id} value={val._id}>
                                    {val.name}
                                  </SelectItem>
                                ))}
                              </SelectContent>
                            </Select>
                          </div>


                          <div className="mb-4 mr-4">
                            <label htmlFor="accountCode">Account Code</label>
                            <Select
                              value={accountCode}
                              onValueChange={(value) => setAccountCode(value)}
                            >
                              <SelectTrigger className="h-9">
                                <SelectValue placeholder="Select Account" />
                              </SelectTrigger>
                              <SelectContent>
                                {xeroAccounts?.map((account) => (
                                  <SelectItem key={account.value} value={account.value}>
                                    {account.label}
                                  </SelectItem>
                                ))}
                              </SelectContent>
                            </Select>
                          </div>
                          <div className="mb-4 mr-4">
                            <label htmlFor="locationname">
                              Completed Released Date
                            </label>
                            <InputShadcn
                              className="h-9"
                              disabled={true}
                              type="text"
                              value={
                                purchaseOrder?.completedReleasedDate
                                  ? moment(
                                    purchaseOrder?.completedReleasedDate
                                  )?.format('DD/MM/YYYY')
                                  : ''
                              }
                              name="completedReleasedDate"
                              id="completedReleasedDate"
                            ></InputShadcn>
                          </div>
                        </Col>
                        <Col className="sm:w-6/12">
                          <div className="mb-4">
                            <label className="control-label">
                              Requested Date
                            </label>
                            <input
                              className="form-control border-black"
                              name="orderStartDate"
                              type="date"
                              value={requestedDate}
                              onChange={(e) =>
                                setRequestedDate(
                                  moment(e.target.value).format('YYYY-MM-DD')
                                )
                              }
                              defaultValue="2019-08-19"
                              id="example-date-input"
                            />
                          </div>
                          <div className="mb-4">
                            <label className="control-label">
                              Expected Release Date
                            </label>
                            <input
                              className="form-control border-black"
                              name="orderStartDate"
                              type="date"
                              value={expectedReleaseDate}
                              onChange={(e) =>
                                setExpectedReleaseDate(
                                  moment(e.target.value).format('YYYY-MM-DD')
                                )
                              }
                              defaultValue="2019-08-19"
                              id="example-date-input"
                            />
                          </div>
                          <div className="mb-4">
                            <label className="control-label">
                              Original Release Date
                            </label>
                            <input
                              className="form-control border-black"
                              name="orderStartDate"
                              type="date"
                              value={originalReleaseDate}
                              onChange={(e) =>
                                setOriginalReleaseDate(
                                  moment(e.target.value).format('YYYY-MM-DD')
                                )
                              }
                              defaultValue="2019-08-19"
                              id="example-date-input"
                            />
                          </div>
                        </Col>
                        <Col className="mt-4 w-full">
                          <Accordian close={loadingSave} title="Stock Produced">
                            <Row>
                              <Col className="sm:w-11/12" />
                              <Col
                                className="sm:w-1/12"
                                style={{ paddingBottom: 8 }}
                              >
                                <CSVLink
                                  data={csvData}
                                  filename={`${reference}_stock_count.csv`}
                                >
                                  <Button
                                    type="button"
                                    variant="secondary"
                                    className="btn-lg btn-rounded"
                                  >
                                    CSV
                                  </Button>
                                </CSVLink>
                              </Col>
                            </Row>
                            <StockInput
                              stock={lines}
                              setStock={setLines}
                              productData={filteredVariants}
                              factoryFobMap={factoryFobMap}
                            />
                            <div className="my-4">
                              <CSVReader
                                onDrop={handleOnDrop}
                                onError={handleOnError}
                                onRemoveFile={handleOnRemoveFile}
                              >
                                <span>
                                  Drop CSV file here or click to upload.
                                </span>
                              </CSVReader>
                              <div className="mt-2 d-flex justify-content-center">
                                <a className='text-[#1f3dd0]' href="https://docs.google.com/spreadsheets/d/1IKRTd60gREBhUgwmo29U81Scbb_fRLmqpKqO_NPNW1w/copy">
                                  {' '}
                                  CSV Template{' '}
                                </a>
                              </div>
                            </div>
                          </Accordian>
                          <Accordian title="Releases">
                            {purchaseOrder?.releases?.map((release) => {
                              const handleUpdateRelease = (status) => {
                                superagent
                                  .post(
                                    `${backendUrl}/purchase-order/release/update-status/${release._id}`
                                  )
                                  .send({ status })
                                  .set(
                                    'Authorization',
                                    `Bearer ${localStorage.getItem('authJWT')}`
                                  )
                                  .set('accept', 'json')
                                  .on('error', (response) => {
                                    const code = response.status;
                                    history.replace(history.location.pathname, {
                                      errorStatusCode: code,
                                    });
                                  })
                                  .then((response) => {
                                    refreshData();
                                  })
                                  .catch((err) => {
                                    console.log(err);
                                  });
                              };
                              return (
                                <div className="pt-6">
                                  <Accordian
                                    title={
                                      <>
                                        {moment(release.dateReleased).format(
                                          'YYYY-MM-DD'
                                        )}
                                        <Badge
                                          className={`float-right ${statusToBadge(release.status)}`}
                                          pill

                                        >
                                          {' '}
                                          {release.status}{' '}
                                        </Badge>
                                      </>
                                    }
                                  >
                                    {release.releaseLines.map((releaseLine) => {
                                      return (
                                        <div className="pt-6">
                                          <div>
                                            {releaseLine.sku} x{' '}
                                            {releaseLine.quantity}
                                          </div>
                                        </div>
                                      );
                                    })}
                                    {release.status === 'pending' && (
                                      <div
                                        style={{
                                          display: 'flex',
                                          flexDirection: 'row',
                                          justifyContent: 'space-between',
                                          padding: '8px 4px',
                                          marginTop: 24,
                                        }}
                                      >
                                        <Button
                                          onClick={() =>
                                            handleUpdateRelease('approved')
                                          }
                                          variant="success"
                                        >
                                          {' '}
                                          Approve{' '}
                                        </Button>
                                        <Button
                                          onClick={() =>
                                            handleUpdateRelease('disapproved')
                                          }
                                          variant="destructive"
                                        >
                                          {' '}
                                          Disapprove{' '}
                                        </Button>
                                      </div>
                                    )}
                                  </Accordian>
                                </div>
                              );
                            })}
                          </Accordian>
                        </Col>
                      </Row>
                      <Row>
                        <Col xs="2" className="sm:w-2/12">
                          <Button
                            onClick={handleSave}
                            type="submit"
                            variant="success"
                            className="mr-1 waves-effect waves-light"
                          >
                            {loadingSave ? 'Saving...' : 'Save Changes'}
                          </Button>
                        </Col>
                        <Col className="xs:w-8/12"></Col>
                        <Col className="xs:w-2/12">
                          <Button
                            disabled={purchaseOrder?.status !== 'approved'}
                            onClick={() => setReleaseModalOpen((prev) => !prev)}
                            className="mr-1 waves-effect waves-light"
                            variant="warning"
                          >
                            {' '}
                            Create Release{' '}
                          </Button>
                        </Col>
                      </Row>
                      <Row style={{ marginTop: 16 }}>
                        <table className="mt-8" style={{ marginBottom: 60 }}>
                          <thead>
                            <tr>
                              <th>SKU</th>
                              <th>Ordered Quantity</th>
                              <th>Released Quantity</th>
                              <th>Remaining Quantity</th>
                            </tr>
                          </thead>
                          <tbody>
                            {Object.keys(poData)
                              .sort((a, b) => a.localeCompare(b))
                              .map((sku) => {
                                return (
                                  <tr>
                                    <td>{sku}</td>
                                    <td>{poData[sku]?.ordered}</td>
                                    <td>{poData[sku]?.released}</td>
                                    <td>
                                      {isNaN(
                                        poData[sku]?.ordered -
                                        poData[sku]?.released
                                      )
                                        ? 0
                                        : poData[sku]?.ordered -
                                        poData[sku]?.released}
                                    </td>
                                  </tr>
                                );
                              })}
                          </tbody>
                        </table>
                      </Row>
                    </div>
                  ) : (
                    <div
                      className="spinner-border text-primary m-1"
                      role="status"
                    >
                      <span className="sr-only">Loading...</span>
                    </div>
                  )}
                </CardBody>
              </Card>
            </Col>
          </Row>
        </div>
      </SupplyChainNav>
      <ReleaseModal
        refreshData={refreshData}
        releaseModalOpen={releaseModalOpen}
        setReleaseModalOpen={setReleaseModalOpen}
        purchaseOrder={purchaseOrder}
        filteredVariants={filteredVariants}
        factoryFobMap={factoryFobMap}
      />
    </>
  );
};

const ReleaseModal = ({
  releaseModalOpen,
  refreshData,
  setReleaseModalOpen,
  purchaseOrder,
  filteredVariants,
  factoryFobMap,
}) => {
  const [lines, setLines] = useState([]);
  const [loading, setLoading] = useState(false);

  const submitRelease = (e) => {
    e.preventDefault();
    if (loading === true) return;

    setLoading(true);

    superagent
      .post(`${backendUrl}/purchase-order/release/create`)
      .send({
        purchaseOrder: purchaseOrder._id,
        releaseLines: lines,
        dateReleased: new Date(),
        status: 'pending',
      })
      .set('Authorization', `Bearer ${localStorage.getItem('authJWT')}`)
      .set('accept', 'json')
      .then((response) => {
        const code = response.status;
        if (code > 400) {
          toast.error('Failed to create release');
        } else {
          setLoading(false);
          setReleaseModalOpen(false);
          refreshData();
        }
      })
      .catch((err) => {
        console.log(err);
        setLoading(false);
        const errorMessage =
          err.response?.body?.message || err.message || 'An error occurred';
        toast.error(errorMessage, {
          autoClose: 5000,
        });
      });
  };

  return (
    <Dialog
      open={releaseModalOpen}
      onOpenChange={() => setReleaseModalOpen((prev) => !prev)}
    >
      <DialogContent className="max-h-[80vh] overflow-y-auto z-[1500] min-w-[60vw]">
        <DialogHeader>Create release</DialogHeader>

        <div>
          <StockInput
            stock={lines}
            setStock={setLines}
            productData={filteredVariants}
            noCost={true}
            factoryFobMap={factoryFobMap}
          />
        </div>

        <DialogFooter>
          <Button variant="success" onClick={submitRelease}>
            {' '}
            Save{' '}
          </Button>
          <Button
            variant="destructive"
            onClick={() => setReleaseModalOpen((prev) => !prev)}
          >
            {' '}
            Cancel{' '}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default PurchaseOrderPage;
